import Navbar from "@/components/site/Navbar";
import { Seo } from "@/components/site/Seo";
import Footer from "@/components/site/Footer";
import Pricing from "@/components/site/Pricing";
import FinalCTA from "@/components/site/FinalCTA";

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] text-[#334155] font-body" data-testid="pricing-page">
      <Seo
        title="Swimming Lesson Prices & Packages | Happy Tiddlers"
        description="Clear, transparent pricing for baby, children's and adult swimming lessons at Happy Tiddlers Swim School in Barton-le-Clay, Bedfordshire."
        path="/pricing"
      />
      <Navbar />
      <main>
        <Pricing />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
